module.exports = "/images/TXR Preview_pages-6.jpg?ac23d81843156a35254fb2744876c54d";